import React from 'react';
import Card from 'components/Card';
import { parseCropHash, getFramedImageStyles } from 'utils/cropUtils';
import { Media } from './styles';

interface IProps {
  src?: string;
  link?: string;
  alt: string;
}

const ImageCard = (props: IProps): JSX.Element | null => {
  const { src, link, alt } = props;
  const { cleanUrl, crop } = parseCropHash(src);
  const { containerStyle, imageStyle } = getFramedImageStyles(crop);

  return (
    <Card>
      <Media style={{ position: 'relative', overflow: 'hidden' }}>
        <div
          style={{
            position: 'absolute',
            top: '-10%',
            left: '-10%',
            width: '120%',
            height: '120%',
            background: `url(${cleanUrl}) center center / cover no-repeat`,
            filter: 'blur(15px)',
            zIndex: 1,
          }}
        />
        <div style={containerStyle}>
          <img src={cleanUrl} alt={alt} style={imageStyle} />
        </div>
        <div style={{ position: 'relative', zIndex: 3, width: '100%', height: '100%' }}>
          {link ? (
            <a href={link} style={{ display: 'block', width: '100%', height: '100%' }}>
              <span className="sr-only">{alt}</span>
            </a>
          ) : (
            <span className="sr-only">{alt}</span>
          )}
        </div>
      </Media>
    </Card>
  );
};

export default ImageCard;
